<template>
  <div id="private">
    <navigation-bar id="navigation-bar"></navigation-bar>
    <div class="container container-top">
      <div class="row">
        <transition name="fade" mode="out-in">
          <!-- 
            NOTE: the key can be used to disable component reuse
            <router-view :key="$route.path"></router-view> 
          -->
          <router-view></router-view>
        </transition>
      </div>
    </div>
    <footer-bar></footer-bar>
  </div>

</template>

<script>
import NavigationBar from "./private-layouts/navigation/NavigationBar";
import FooterBar from "./private-layouts/FooterBar";

export default {
  name: "private-layout",
  components: {FooterBar, NavigationBar}
}
</script>

<style scoped lang="scss">
  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  #navigation-bar {
    position: sticky;
    top: 0;
    z-index: 1;
  }
</style>